<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'operation-data-view'
};
</script>
